import {useParams} from "react-router-dom";
import {useAppContext} from "../../AppContext";
import {useEffect, useMemo} from "react";
import {YnaProSubscriptionConfig} from "../../components/settings/components/YnaPro/YnaPro";
import {ActiveSubscription} from "../../components/settings/components/ActiveSubscription/ActiveSubscription";
import {observer} from "mobx-react";

export const MobileSubscriptionsManage = observer(() => {
  const { token, selectedPlanId } = useParams();

  const {
    store: { subscriptionPlanStore, settingsStore },
  } = useAppContext();
  
  useEffect(() => {
    subscriptionPlanStore.loadSubscriptionPlans(token).then(() => {
      const activePlan = subscriptionPlanStore.subscriptionPlans.find(s => s.id === selectedPlanId);
      if (!activePlan) {
        return;
      }
      
      const endDateFormatted = activePlan.endDate
        ? new Date(activePlan.endDate).toLocaleDateString("ru-RU")
        : undefined;

      settingsStore.setYnaProActivePlan(
        activePlan.id,
        activePlan.name,
        "success",
        activePlan.price,
        endDateFormatted
      );
    });
  }, [subscriptionPlanStore]);

  const allPlans = subscriptionPlanStore.subscriptionPlans;

  const subscriptions: YnaProSubscriptionConfig[] = useMemo(() => {
    return allPlans.map((plan) => {
      const endDateFormatted = plan.endDate
        ? new Date(plan.endDate).toLocaleDateString("ru-RU")
        : undefined;
      
      return {
        id: plan.id,
        name: plan.name,
        description:
          plan.description ||
          `Следующий платёж ${plan.price} руб. спишется ${
            endDateFormatted || ""
          }`,
        chipType: plan.isActive ? "success" : "warning",
        active: plan.isActive,
        // disabled: !plan.isActive,
        price: plan.price,
        nextBillingDate: endDateFormatted,
        features: (plan.features || []).map((feature, index) => ({
          id: `${plan.id}-feature-${index}`,
          label: feature,
        })),
      };
    });
  }, [allPlans]);
  
  const currentSubscription = subscriptions.find(s => s.id === selectedPlanId);

  if (!currentSubscription) {
    return <></>
  }
  
  return <ActiveSubscription token={token} mobile />
});